import invitationSlice from './slice'

export default invitationSlice.reducer
